import {
  ChangeDetectionStrategy,
  Component,
  input,
  linkedSignal,
  model,
  output,
} from '@angular/core';

@Component({
  selector: 'ups-notes',
  templateUrl: 'notes.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotesComponent {
  readonly previousNotes = input<string>();
  readonly isDisabled = input(false);
  readonly hidePreviousNotes = input(false);
  readonly hidePreviousNotesLabel = input(true);
  readonly hideNewNote = input(false);
  readonly newNote = model<string>();

  readonly newNoteChanged = output<string>();

  // done like this to keep previous behaviour
  protected readonly newNoteInternal = linkedSignal(() => this.newNote());

  constructor() {}

  onNewNoteChange() {
    this.newNoteChanged.emit(this.newNoteInternal()!);
  }
}
